module.exports = __webpack_public_path__ + "static/media/020-man-4.11a89b8f.svg";